<template>
   <div class="site-contents dashboard d-flex align-items-center flex-wrap">
    <div class="container">
      <div class="event-lists events-wrap d-flex flex-wrap justify-content-between">
      <div v-html="content" class="public-page-content"></div>
    </div>
  </div>
   </div>
</template>

<script>
import Info from "./Info";
import { PUBLIC_PAGES } from "../../store/auth/action.type";
export default {
  data() {
    return {
      slug: "terms-conditions",
      content: ""
    };
  },
  mounted() {
    this.$store
      .dispatch(PUBLIC_PAGES, this.slug)
      .then(response => {
        this.content = response.data.data.content;
      })
      .catch(error => {
        console.log(error);
      });
  }
};
</script>

<style scoped>
.public-page-content {
  all: unset;
  line-height: 23px;
}
.public-page-content >>> strong  {
  font-weight: 500;
  /* font-size: 20px; */
}
.public-page-content >>> p  {
  margin-top: 21px;
}
.public-page-content >>> h4  {
  font-family: "Rubik", sans-serif;
  font-weight: 500;
  font-size: 20px;
}
</style>